import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'


/**
 * 获取企业欠薪列表
 * @param data 查询条件
 */
export function getEnterpriseList(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayComComplaintInfo/gl/v1.0.0/page`,
        method: 'post',
        data
    })
}

/**
 * 获取企业欠薪详情
 * @param data 查询条件
 */
export function getEnterpriseDetail(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayComComplaintInfo/gl/v1.0.0/detail`,
        method: 'post',
        data
    })
}

/**
 * 获取处置信息
 * @param data 查询条件
 */
export function getRecodList(data) {
    return request({
     url:`/${systemConfig.unpaidWagesPrefix}/backpayComplaintRecord/gl/v1.0.0/list`,
     method: "post",
     data
    })
  }


/**
 * 提交处置信息
 * @param data 提交数据
 */
export function submitDisposal(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayComComplaintInfo/gl/v1.0.0/dispose`,
        method: 'post',
        data
    })
}

/**
 * 结案审核
 * @param data 提交数据
 */
export function submitCase(data) {
    return request({
        url: `/${systemConfig.unpaidWagesPrefix}/backpayComComplaintInfo/gl/v1.0.0/case`,
        method: 'post',
        data
    })
}
